import { render, staticRenderFns } from "./mainRight.vue?vue&type=template&id=22c62822&scoped=true&"
import script from "./mainRight.vue?vue&type=script&lang=js&"
export * from "./mainRight.vue?vue&type=script&lang=js&"
import style0 from "./mainRight.vue?vue&type=style&index=0&id=22c62822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c62822",
  null
  
)

export default component.exports